import Logger from '../../lib/Logger';
import { LANGUAGE, URL_SEARCH_PARAM } from '../utils.constant';
import { AnalyticsType } from '../../types/Analytics';
import { AnalyticsUtils } from './AnalyticsUtils';
import { analyticsEmitter } from './AnalyticsEventEmitter';
import { getMetaProerties, getReferralChannel, sanitizeParams, } from '../auth/check-params';
class RudderStack {
    static get ready() {
        return RudderStack.isReady;
    }
    static setNewIdentity(userProperties, referralParams) {
        Object.keys(referralParams).forEach(key => {
            if (key.match(this.CUSTOM_RUDDER_PROPERTIES_REGEX) &&
                !!referralParams[key]) {
                if ([URL_SEARCH_PARAM.MS_CLK_ID, URL_SEARCH_PARAM.FB_CL_ID].includes(key)) {
                    userProperties[`${key}`] = referralParams[key];
                }
                else {
                    userProperties[`initial_${key}`] = referralParams[key];
                }
            }
        });
    }
    static updateIdentify(userProps) {
        const userDetails = AnalyticsUtils.getSanitizedUser();
        const userId = userDetails?.id?.toString() ?? '';
        RudderStack.rudderanalytics.identify(userId, AnalyticsUtils.transformPropertiesToSnakeCase(userProps));
    }
    static reset(resetAnonymousId = false) {
        RudderStack.rudderanalytics.reset(resetAnonymousId);
    }
    static identify() {
        const userDetails = AnalyticsUtils.getSanitizedUser();
        const userId = userDetails?.id?.toString() ?? '';
        if (userId) {
            RudderStack.rudderanalytics.identify(userId, {
                ...AnalyticsUtils.getSanitizedUserV2(),
            });
        }
    }
    static async init({ language = 'en', config = {}, callback = () => { }, }) {
        RudderStack.rudderanalytics = await import('rudder-sdk-js');
        RudderStack.rudderanalytics.load(config.WRITE_KEY, config.DATA_PLANE_URL, {
            sessions: {
                autoTrack: true,
                timeout: 20 * 60 * 1000,
            },
            sendAdblockPage: true,
            sendAdblockPageOptions: {
                integrations: {
                    All: true,
                },
            },
            configUrl: config.CONFIG_URL,
        });
        RudderStack.rudderanalytics.ready(() => {
            Logger.logEvent(AnalyticsType.RUDDER_STACK, 'Initialization Complete');
            RudderStack.identify();
            RudderStack.isReady = true;
            analyticsEmitter.emit('rudderstack', { isReady: true });
            AnalyticsUtils.setAnonymousId(this.rudderanalytics.getAnonymousId());
            callback();
        });
    }
    static getEventPageProperties() {
        const referralParams = getReferralChannel();
        const userReferralProperties = {};
        if (!!AnalyticsUtils.getPage() && !!referralParams) {
            userReferralProperties['type'] =
                AnalyticsUtils.toSnakeCase(AnalyticsUtils.getPage());
        }
        if (referralParams) {
            RudderStack.setNewIdentity(userReferralProperties, referralParams);
            if (referralParams.Channel) {
                userReferralProperties.Channel =
                    referralParams.Channel;
            }
        }
        userReferralProperties['url'] = window.location.href;
        userReferralProperties['source'] = sanitizeParams();
        return { page: userReferralProperties };
    }
    static async load({ language = 'en', config = {}, callback = () => { }, }) {
        if (!window) {
            return;
        }
        let _language = 'English';
        if (language in LANGUAGE) {
            _language = LANGUAGE[language];
        }
        RudderStack.init({ language: _language, config, callback });
    }
    static send({ eventName, eventData, userData, extraData, }) {
        const eventWithPageData = {
            ...RudderStack.getEventPageProperties(),
            ...eventData,
        };
        RudderStack.rudderanalytics.track(eventName, {
            ...eventWithPageData,
            ...userData,
            ...extraData,
        });
    }
    static page(name) {
        this.rudderanalytics.page(name, name, {
            ...AnalyticsUtils.commonRudderStackEventProperties(),
            page: {
                name: name,
                category: 'iv_' + name,
            },
            ...getMetaProerties(),
        });
    }
}
RudderStack.isReady = false;
RudderStack.CUSTOM_RUDDER_PROPERTIES_REGEX = /^((?!utm_(source|medium|campaign|term|content)|referrer|referring_domain|gclid|Channel).)*$/;
export { RudderStack };
